/* tslint:disable */
/* eslint-disable */
/**
 * Syte Products API
 * API services for CRA, Files, and Collaborators
 *
 * The version of the OpenAPI document: v0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CapabilityDtoFromJSON, CapabilityDtoToJSON, } from './CapabilityDto';
import { LeftNavDisplayFromJSON, LeftNavDisplayToJSON, } from './LeftNavDisplay';
import { OrganizationDTOFromJSON, OrganizationDTOToJSON, } from './OrganizationDTO';
import { ProspectInfoFromJSON, ProspectInfoToJSON, } from './ProspectInfo';
/**
 * Check if a given object implements the OrganizationUserDTO interface.
 */
export function instanceOfOrganizationUserDTO(value) {
    let isInstance = true;
    return isInstance;
}
export function OrganizationUserDTOFromJSON(json) {
    return OrganizationUserDTOFromJSONTyped(json, false);
}
export function OrganizationUserDTOFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'organizationDto': !exists(json, 'organizationDto') ? undefined : OrganizationDTOFromJSON(json['organizationDto']),
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'lastUsedDateTime': !exists(json, 'lastUsedDateTime') ? undefined : (new Date(json['lastUsedDateTime'])),
        'role': !exists(json, 'role') ? undefined : json['role'],
        'capabilities': !exists(json, 'capabilities') ? undefined : (json['capabilities'].map(CapabilityDtoFromJSON)),
        'sponsorLogoFile': !exists(json, 'sponsorLogoFile') ? undefined : json['sponsorLogoFile'],
        'sponsor': !exists(json, 'sponsor') ? undefined : json['sponsor'],
        'sponsorDisplayName': !exists(json, 'sponsorDisplayName') ? undefined : json['sponsorDisplayName'],
        'displaySecureTab': !exists(json, 'displaySecureTab') ? undefined : json['displaySecureTab'],
        'displayExternalVulnScan': !exists(json, 'displayExternalVulnScan') ? undefined : json['displayExternalVulnScan'],
        'displayExternalVulnScanV2': !exists(json, 'displayExternalVulnScanV2') ? undefined : json['displayExternalVulnScanV2'],
        'displayAssessTab': !exists(json, 'displayAssessTab') ? undefined : json['displayAssessTab'],
        'displayEssentialsTab': !exists(json, 'displayEssentialsTab') ? undefined : json['displayEssentialsTab'],
        'displaySecure0722Tab': !exists(json, 'displaySecure0722Tab') ? undefined : json['displaySecure0722Tab'],
        'displayIRPlanBuilder': !exists(json, 'displayIRPlanBuilder') ? undefined : json['displayIRPlanBuilder'],
        'hasIRJumpStartRetainer': !exists(json, 'hasIRJumpStartRetainer') ? undefined : json['hasIRJumpStartRetainer'],
        'displaySecurityProjects': !exists(json, 'displaySecurityProjects') ? undefined : json['displaySecurityProjects'],
        'hasAWNMDR': !exists(json, 'hasAWNMDR') ? undefined : json['hasAWNMDR'],
        'hasAWNMA': !exists(json, 'hasAWNMA') ? undefined : json['hasAWNMA'],
        'hasAWNMR': !exists(json, 'hasAWNMR') ? undefined : json['hasAWNMR'],
        'hasAWNIRJS': !exists(json, 'hasAWNIRJS') ? undefined : json['hasAWNIRJS'],
        'hasFreeThreatScan': !exists(json, 'hasFreeThreatScan') ? undefined : json['hasFreeThreatScan'],
        'hasThreatScanTrial': !exists(json, 'hasThreatScanTrial') ? undefined : json['hasThreatScanTrial'],
        'hasThreatScanPaid': !exists(json, 'hasThreatScanPaid') ? undefined : json['hasThreatScanPaid'],
        'hasScanSponsored': !exists(json, 'hasScanSponsored') ? undefined : json['hasScanSponsored'],
        'threatScanTrialExpiry': !exists(json, 'threatScanTrialExpiry') ? undefined : (new Date(json['threatScanTrialExpiry'])),
        'threatScanPaidExpiry': !exists(json, 'threatScanPaidExpiry') ? undefined : (new Date(json['threatScanPaidExpiry'])),
        'hasCRACustomer': !exists(json, 'hasCRACustomer') ? undefined : json['hasCRACustomer'],
        'hasCRABroker': !exists(json, 'hasCRABroker') ? undefined : json['hasCRABroker'],
        'hasCRAProspect': !exists(json, 'hasCRAProspect') ? undefined : json['hasCRAProspect'],
        'hasIRPlannerProspect': !exists(json, 'hasIRPlannerProspect') ? undefined : json['hasIRPlannerProspect'],
        'irPlannerProspect': !exists(json, 'irPlannerProspect') ? undefined : ProspectInfoFromJSON(json['irPlannerProspect']),
        'craProspectExpired': !exists(json, 'craProspectExpired') ? undefined : json['craProspectExpired'],
        'hasGuidesProspect': !exists(json, 'hasGuidesProspect') ? undefined : json['hasGuidesProspect'],
        'craProspectExpirationDate': !exists(json, 'craProspectExpirationDate') ? undefined : (new Date(json['craProspectExpirationDate'])),
        'craProspectExpirationDays': !exists(json, 'craProspectExpirationDays') ? undefined : json['craProspectExpirationDays'],
        'leftNavDisplay': !exists(json, 'leftNavDisplay') ? undefined : LeftNavDisplayFromJSON(json['leftNavDisplay']),
    };
}
export function OrganizationUserDTOToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'organizationDto': OrganizationDTOToJSON(value.organizationDto),
        'userId': value.userId,
        'lastUsedDateTime': value.lastUsedDateTime === undefined ? undefined : (value.lastUsedDateTime.toISOString()),
        'role': value.role,
        'capabilities': value.capabilities === undefined ? undefined : (value.capabilities.map(CapabilityDtoToJSON)),
        'sponsorLogoFile': value.sponsorLogoFile,
        'sponsor': value.sponsor,
        'sponsorDisplayName': value.sponsorDisplayName,
        'displaySecureTab': value.displaySecureTab,
        'displayExternalVulnScan': value.displayExternalVulnScan,
        'displayExternalVulnScanV2': value.displayExternalVulnScanV2,
        'displayAssessTab': value.displayAssessTab,
        'displayEssentialsTab': value.displayEssentialsTab,
        'displaySecure0722Tab': value.displaySecure0722Tab,
        'displayIRPlanBuilder': value.displayIRPlanBuilder,
        'hasIRJumpStartRetainer': value.hasIRJumpStartRetainer,
        'displaySecurityProjects': value.displaySecurityProjects,
        'hasAWNMDR': value.hasAWNMDR,
        'hasAWNMA': value.hasAWNMA,
        'hasAWNMR': value.hasAWNMR,
        'hasAWNIRJS': value.hasAWNIRJS,
        'hasFreeThreatScan': value.hasFreeThreatScan,
        'hasThreatScanTrial': value.hasThreatScanTrial,
        'hasThreatScanPaid': value.hasThreatScanPaid,
        'hasScanSponsored': value.hasScanSponsored,
        'threatScanTrialExpiry': value.threatScanTrialExpiry === undefined ? undefined : (value.threatScanTrialExpiry.toISOString()),
        'threatScanPaidExpiry': value.threatScanPaidExpiry === undefined ? undefined : (value.threatScanPaidExpiry.toISOString()),
        'hasCRACustomer': value.hasCRACustomer,
        'hasCRABroker': value.hasCRABroker,
        'hasCRAProspect': value.hasCRAProspect,
        'hasIRPlannerProspect': value.hasIRPlannerProspect,
        'irPlannerProspect': ProspectInfoToJSON(value.irPlannerProspect),
        'craProspectExpired': value.craProspectExpired,
        'hasGuidesProspect': value.hasGuidesProspect,
        'craProspectExpirationDate': value.craProspectExpirationDate === undefined ? undefined : (value.craProspectExpirationDate.toISOString()),
        'craProspectExpirationDays': value.craProspectExpirationDays,
        'leftNavDisplay': LeftNavDisplayToJSON(value.leftNavDisplay),
    };
}
